/**
 * The single source of truth for anything the client and the server must agree
 * about: types, enums, reference data and validation schemas.
 *
 * If you find yourself retyping an enum, a procedure key or a HiLLO number
 * anywhere else in the codebase, stop and import it from here instead.
 */
export const APP_VERSION = '0.1.0';
export * from './aggregate.js';
export * from './derive.js';
export * from './enums.js';
export * from './export.js';
export * from './errors.js';
export * from './hillos.js';
export * from './import.js';
export * from './importProfiles.js';
export * from './procedures.js';
export * from './schemas.js';
export * from './sync.js';
export * from './types.js';
//# sourceMappingURL=index.js.map